import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { GiHeartOrgan } from "react-icons/gi";
import OrganModal from "../../Modal/SurgeryModal/OrganModal";
import { useDispatch, useSelector } from "react-redux";
import { getOrganAction } from "../../Actions/SurgeryAction/SurgeryAction";
import { RxUpdate } from "react-icons/rx";

import LoadingPage from "../Loading/LoadingPage";

const Organ = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [organ, setOrgan] = useState(null);
  const [debounceValue, setDebounceValue] = useState(null);
  const dispatch = useDispatch();
  const getOrgan = useSelector((state) => state.getOrgan);
  const { loading, organs } = getOrgan;
  const [name, setName] = useState(null);
  const [kuname, setKuname] = useState(null);
  const [id, setId] = useState(null);
  const [typeSurgeryId, setTypeSurgeryId] = useState(null);
  useEffect(() => {
    dispatch(getOrganAction(debounceValue));
  }, [debounceValue, dispatch]);

  const handleIndex = (name, kuname, id,typeSurgeryId) => {
    setTypeSurgeryId(typeSurgeryId);
    setName(name);
    setKuname(kuname);
    setId(id);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(organ);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [organ]);
  return (
    <>
      <div className="parent">
        <div className="flex justify-between gap-2 px-2 items-center">
          <div className="flex gap-1 items-center font-bold text-blue-600">
            <GiHeartOrgan />
            <p>Organ Level</p>
          </div>
          <div className="mt-1">
            <button
              className="btn-primary flex gap-2 items-center"
              onClick={() => setIsOpenModal(true)}
            >
              <p>Add Organ Level</p>
              <FaPlus />
            </button>
          </div>
        </div>
        <div className="w-full p-2">
          <input
            type="text"
            className="input w-full"
            placeholder="Search By Organ"
            value={organ}
            onChange={(e) => setOrgan(e.target.value)}
          />
        </div>
        {loading ? (
          <LoadingPage />
        ) : (
          <div className="parent-table">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Organ Level</th>
                  <th>TYP</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {organs?.map((organ, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>

                      <td>{organ.en_name}</td>

                      <td>{organ.ku_name}</td>

                      <td>
                        <button
                          onClick={
                            () => {
                      
                              setIsOpenModal(true);
                              handleIndex(
                                organ.en_name,
                                organ.ku_name,
                                organ.id,
                                organ.type_surgery_id
                              );
                            }
                            // handleIndex(index, organ.en_name,organ.ku_name, organ.id)
                          }
                          className="btn-primary flex gap-2 items-center"
                        >
                          Update
                          <RxUpdate />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {isOpenModal && (
          <OrganModal
            en_name={name}
            ku_name={kuname}
            id={id}
            typeSurgeryId={typeSurgeryId}
            // typeSurgeryId={1}
            closeModal={() => {
              setIsOpenModal(false)
              setId(null)
              setName(null)
              setKuname(null)
            }}
          />
        )}
      </div>
    </>
  );
};

export default Organ;
